/**
 * Component: Country selector
 * ------------------------------------------------------------------------------
 * A loosely coupled script to emit store data based on a country/Country dropdown
 * - Used in conjunction with the Country-selector.liquid snippet
 *
 * @namespace countrySelector
 */
import log from 'salvo-lite/log'
import Cookies from 'js-cookie'
import axios from 'axios'
import emojiFlags from 'emoji-flags'
import {getSiblings, getBrowser, on} from '../helpers/utils'

class CountrySelector {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            container: '[js-country-selector="container"]',
            selector: '[js-country-selector="selector"]',
            icon: '[js-country-selector="icon"]',
            ...JSON.parse(elem.getAttribute('data-country') || '{}')
        }
        this._container = [...document.querySelectorAll(this._settings.selector) || null]
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        // if (!this._isCountrySelectorEnabled()) {
        // return
        // }

        // if (binder.isSet()) {
        // return
        // }

        this._renderOptions()
        this._updateFlagIcon()
        this._setTriggerEvents()
        // binder.set()
    }

    /**
     * Set listeners.
     */
    _setTriggerEvents () {
        this._container.forEach((element) => {
            on('change', element, () => this._onSelectChange(element))
        })
    }

    /**
     * Render redirect options in country selector.
     */
    _renderOptions () {
        const template = this._getRedirectOptionTemplate()

        this._container.forEach((element) => {
            element.innerHTML += template
        })
    }

    /**
     * Get available redirect options.
     */
    _getRedirectOptionTemplate () {
        return window.Frame.Redirects.map((option) => {
            if (option.country_code) {
                return `
                <option value="${option.country_code}"
                    data-country-code="${option.country_code}"
                    data-continent-code="${option.continent_code}"
                >
                    ${option.country_name}
                </option>`
            }
            return `
                <option value="${option.continent_code}"
                data-continent-code="${option.continent_code}"
                >
                ${option.continent_code}
                </option>`
        }).join('')
    }

    /**
     * Handle change event on Country selectors.
     * @param {HTMLElement} element - Selected drop-down.
     */
    _onSelectChange (element) {
        Cookies.set('default_country', element.value, {expires: 7})
        const payload = {selected: element.value}
        this._updateFlagIcon()
        this._fetchUserGeolocation(payload)
        window.Frame.EventBus.emit('CountrySelector:change', payload)
    }

    /**
     * Emit user geolocation information from response.
     */
    _getUserGeolocation (response) {
        return {
            location: {
                continent: response.continent_code,
                country: response.country_code,
                name: response.country_name
            },
            currency: {
                code: response.currency.code,
                symbol: response.currency.symbol,
                name: response.currency.name
            }
        }
    }

    /**
     * Return Geolocation data of current user.
     * @param {payload} - default emitted data from dropdown selector.
     */
    _fetchUserGeolocation (payload) {
        axios.get('https://ford-endpoints.herokuapp.com/api/geolocation')
            .then((response) => {
                const geoPayload = Object.assign(payload, this._getUserGeolocation(response.data))

                window.Frame.EventBus.emit('CountrySelector:change', geoPayload)
                return response
            })
            .catch((err) => {
                if (err.name === 'Error' && getBrowser() === 'Internet Explorer') {
                    window.alert(window.theme.strings.geoLocationError)
                }
                throw new Error(err)
            })
    }

    /**
     * Update flag image with selected country.
     */
    _updateFlagIcon () {
        this._container.forEach((element) => {
            const selectedOption = element.options[element.selectedIndex]
            const selectedCountryCode = selectedOption.dataset.countryCode || selectedOption.dataset.continentCode
            const flag = emojiFlags.countryCode(selectedCountryCode)

            getSiblings(element)[0].querySelector(this._settings.icon).innerHTML = flag.emoji
        })
    }

    /**
     * Check if country selector exists on DOM.
     */
    _isCountrySelectorEnabled () {
        return this._container
    }

    /**
     * Expose public interface
     */
    // return Object.freeze({
    //     init,
    // })
}

export default CountrySelector



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CountrySelector.js